module.exports = __webpack_public_path__ + "media/images/lp_v6_step02-1dfba4956af9771dbd0d5180e365a773.webp";